const toString = window.Symbol && window.Symbol.toStringTag;

export default toString;
